import script from "./ApplicationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationsPage.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationsPage.vue?vue&type=style&index=0&id=29e0ebd8&scoped=true&lang=css"

import exportComponent from "/opt/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e0ebd8"]])

export default __exports__